const QuestionBank = () => {
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-semibold text-gray-900">Banco de Preguntas</h1>
        <p className="mt-1 text-sm text-gray-500">
          Explora las preguntas que Worky utiliza en las simulaciones de entrevistas
        </p>
      </div>
    </div>
  );
};

export default QuestionBank; 